var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8954_191)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2182 9.58289C38.1996 10.3531 37.5614 10.9634 36.7912 10.9466C36.0209 10.928 35.4107 10.2899 35.4274 9.51963L35.5037 6.15959L32.1455 6.08331C31.3753 6.0647 30.7651 5.42656 30.7818 4.65631C30.8004 3.88607 31.4386 3.27583 32.2088 3.29257L36.9642 3.40234C37.7345 3.41909 38.3447 4.05723 38.3261 4.82748L38.2182 9.58289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51546 15.0621V37.6503C8.51546 38.9489 7.46429 40.0001 6.16567 40.0001H2.3498C1.05118 40.0001 0 38.9489 0 37.6503V15.0621C0 13.7653 1.05118 12.7123 2.3498 12.7123H6.16567C7.46429 12.7123 8.51546 13.7653 8.51546 15.0621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5055 26.5114V37.6502C29.5055 38.2734 29.2581 38.8707 28.8171 39.3116C28.3762 39.7525 27.779 40 27.1557 40H23.3399C22.7166 40 22.1194 39.7525 21.6784 39.3116C21.2375 38.8707 20.9901 38.2734 20.9901 37.6502V26.5114C20.9901 25.8882 21.2375 25.2909 21.6784 24.85C22.1194 24.4091 22.7166 24.1616 23.3399 24.1616H27.1557C27.779 24.1616 28.3762 24.4091 28.8171 24.85C29.2581 25.2909 29.5055 25.8882 29.5055 26.5114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0105 20.7867V37.6502C19.0105 38.9488 17.9593 40 16.6607 40H12.8448C11.5462 40 10.495 38.9488 10.495 37.6502V20.7867C10.495 20.1634 10.7425 19.5662 11.1834 19.1253C11.6243 18.6843 12.2216 18.4369 12.8448 18.4369H16.6607C17.9593 18.4369 19.0105 19.4899 19.0105 20.7867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0005 20.7867V37.6502C40.0005 38.9488 38.9494 40 37.6507 40H33.8349C32.5363 40 31.4851 38.9488 31.4851 37.6502V20.7867C31.4851 20.1634 31.7325 19.5662 32.1735 19.1253C32.6144 18.6843 33.2116 18.4369 33.8349 18.4369H37.6507C38.9494 18.4369 40.0005 19.4899 40.0005 20.7867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2326 2.51112C1.61491 2.04972 1.49026 1.17343 1.95352 0.557604C2.41492 -0.0582183 3.28935 -0.182871 3.90704 0.27853L14.9825 8.58562H20.2421C20.6719 8.58562 21.0756 8.78283 21.3398 9.11958L25.5948 14.5355L35.4554 4.2451C35.9875 3.68881 36.8712 3.6702 37.4275 4.20417C37.9838 4.73627 38.0024 5.62 37.4703 6.17629L26.4971 17.6257C26.218 17.9178 25.8255 18.0741 25.4217 18.0537C25.018 18.0351 24.6422 17.8397 24.3929 17.5216L19.5649 11.3764H14.5174C14.216 11.3764 13.9221 11.2796 13.6802 11.0973L2.2326 2.51112Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8954_191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1);
export default __webpack_public_path__ + "static/media/s1.41fbc293a6aff9bc1422453c6ba13cca.svg";
export { ForwardRef as ReactComponent };